import fetch from '../utils/fetch';
import { saURL } from 'endpoints';
import { v4 as uuid } from 'uuid';
import * as Promise from 'bluebird';
import { sortMilestones } from '../utils/milestones';

class ServiceAwardsSDK {

    getPrograms = () => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/programs` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( programs ) => {
                        resolve( programs );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    getProgram = ( programId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/programs/${ programId }` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( program ) => {
                        resolve( program );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    postProgram = ( program ) => {
        if ( !program.programId ) {
            program.programId = uuid();
        }
        if ( !program.programStartDate ) {
            program.programStartDate = new Date().toISOString();
        }

        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/programs`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify( program )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        if ( data.stack ) {
                            console.error( data.stack );
                        }

                        if ( Array.isArray( data ) ) {
                            reject( new Error( data.map( e => e.message ).join( '\n' ) ) );
                        } else {
                            reject( new Error( data ) );
                        }
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };
    getPreferences = () => {
        return new Promise( ( resolve, reject ) => {

            fetch( `${ saURL }/company-preferences` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( settings ) => {
                        resolve( settings );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };
    updatePreferences = ( preferences ) => {
        return new Promise( ( resolve, reject ) => {

            fetch( `${ saURL }/company-preferences`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify( preferences )
            }  )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( preferenceSettings ) => {
                        resolve( preferenceSettings );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };
    getMilestones = ( programId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/milestones/?programId=${ programId }` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( milestones ) => {
                        resolve( sortMilestones( milestones ) );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        const errorMessage = JSON.stringify( data );
                        reject( new Error( errorMessage ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    getMilestone = ( milestoneId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/milestones/${ milestoneId }` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( milestone ) => {
                        resolve( milestone );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    postMilestone = ( milestone ) => {
        if ( !milestone.milestoneId ) {
            milestone.milestoneId = uuid();
        }

        return new Promise( ( resolve, reject ) => {

            fetch( `${ saURL }/milestones`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify( milestone )
            } )
            .then( ( res ) => {
                if ( res.ok ) {

                    resolve( milestone );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    deleteMilestone = ( milestoneId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/milestones/${ milestoneId }`, {
                method: 'DELETE'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    resolve();
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    getRecipient = ( recipientId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/recipients/${ recipientId }` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( recipient ) => {
                        resolve( recipient );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };
    updateRecipient = ( recipientId, data ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/recipients/${ recipientId }`, {
                method: 'POST',
                body: JSON.stringify( data ),
                headers: { 'content-type': 'application/json' }
            } )
                .then( ( res ) => {
                    if ( res.ok ) {
                        res.json().then( ( data ) => {
                            resolve( data );
                        } );
                    } else {
                        res.json().then( ( data ) => {
                            reject( new Error( data ) );
                            alert( data.message );
                        } );
                    }
                } )
                .catch( ( err ) => {
                    console.error( err );
                    reject( new Error( err.message ) );
                } );
        } );
    };

    resendContributorEmails = async ( recipientId, emailType ) => {
        try {
            const res = await fetch( `${ saURL }/recipients/${ encodeURIComponent( recipientId ) }/contributors/emails/${ encodeURIComponent( emailType ) }`, {
                method: 'POST'
            } );
            const json = await res.json();
            if ( json.success ) {
                return json;
            }
            throw json;
        } catch ( error ) {
            console.error( error );
            throw error;
        }
    };

    getAwardFiles = ( programId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/award-files/?programId=${ programId }` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( awardFiles ) => {
                        resolve( awardFiles );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    getAwardFile = ( awardFileId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/award-files/${ awardFileId }` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( awardFile ) => {
                        resolve( awardFile );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    getAwardFileRecords = ( awardFileId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/award-files/${ awardFileId }/records` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( records ) => {
                        resolve( records );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };
    getAwardFileErrors = ( awardFileId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/award-files/${ awardFileId }/records/errors` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( records ) => {
                        resolve( records );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };
    refreshErrors = ( awardFileId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/award-files/${ awardFileId }/records/errors/refresh`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( {} )
            }  )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( records ) => {
                        resolve( records );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };
    getAwardFilePersonFile = ( awardFileId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/award-files/${ awardFileId }/person-files` )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.text().then( ( records ) => {
                        resolve( records );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data.message ) );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    postAwardFile = ( data ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/award-files`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( data )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        // Preserve the HTTP status and the raw response body (in addition to
                        // the message) so callers can detect specific cases like a 409
                        // conflict - which references an in-flight awardFileId - rather than
                        // only having a plain error message to work with.
                        const error = new Error( data.message );
                        error.status = res.status;
                        error.body = data;
                        reject( error );
                    } );
                }
            } )
            .catch( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    getMilestoneKey = ( milestone ) =>`${ milestone.milestoneCode }_${ milestone.countryCode ? milestone.countryCode : '' }`;

    generateMilestones = ( programId, milestones, levels ) => {
        return new Promise( ( resolve, reject ) => {
            const expectedLevelMap = {};
            levels.forEach( ( { maxValue, levelName, countryCode } ) => {
                const milestoneFromLevel = {
                    programId,
                    milestoneId: uuid(),
                    milestoneName: {},
                    milestoneCode: levelName,
                    countryCode,
                    maxAward: maxValue,
                    messageLevelLabel: {},
                    useSharedMilestone: true
                };
                const key = this.getMilestoneKey( milestoneFromLevel );
                expectedLevelMap[ key ] = milestoneFromLevel;

                const sharedId = uuid();
                const sharedKey = this.getMilestoneKey( {
                    ...milestoneFromLevel,
                    milestoneId: sharedId,
                    countryCode: null,
                    maxAward: null,
                    useSharedMilestone: false
                } );
                expectedLevelMap[ sharedKey ] = {
                    ...milestoneFromLevel,
                    milestoneId: sharedId,
                    countryCode: null,
                    maxAward: null,
                    useSharedMilestone: false
                };
            } );

            const existingMilestoneMap = {};
            const milestoneIdsToDelete = [];
            const sharedMilestonesToCreate = [];
            const countryMilestonesToCreate = [];

            milestones.forEach( ( milestone ) => {
                const key = this.getMilestoneKey( milestone );

                // delete any milestones that are no longer in levels
                if ( !expectedLevelMap[ key ] ) {
                    return milestoneIdsToDelete.push( milestone.milestoneId );
                }

                if ( !existingMilestoneMap[ key ] ) {
                    existingMilestoneMap[ key ] = milestone;
                } else {
                    // delete any milestones with the same level/country
                    milestoneIdsToDelete.push( milestone.milestoneId );
                }
            } );

            Object.keys( expectedLevelMap ).forEach( key => {
                // if there is a new level that doesn't have a milestone yet, create one
                if ( !existingMilestoneMap[ key ] ) {
                    const milestoneToCreate = expectedLevelMap[ key ];

                    existingMilestoneMap[ key ] = milestoneToCreate;
                    if ( milestoneToCreate.countryCode ) {
                        countryMilestonesToCreate.push( milestoneToCreate );
                    } else {
                        sharedMilestonesToCreate.push( milestoneToCreate );
                    }
                }
            } );

            return Promise.map( milestoneIdsToDelete, ( milestoneId ) => this.deleteMilestone( milestoneId ), { concurrency: 5 } ).then( () => {
                // shared milestones need to be created first so country milestones can use them
                return Promise.map( sharedMilestonesToCreate, ( sharedMilestone ) => this.postMilestone( sharedMilestone ), { concurrency: 5 } ).then( () => {
                    return Promise.map( countryMilestonesToCreate, ( countryMilestone ) => this.postMilestone( countryMilestone ), { concurrency: 5 } ).then( () => {
                        return resolve( sortMilestones( Object.values( existingMilestoneMap ) ) );
                    } );
                } );
            } ).catch( err => {
                console.error( err );
                return reject( new Error( err.message ) );
            } );
        } );
    };

    award = ( recipientId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/recipients/${ recipientId }/awards`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' }
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                }
            } )
            .catch( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };

    sendEmail = ( recipientId, type ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/recipients/${ recipientId }/emails/${ type }`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' }
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                }
            } )
            .catch( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };



    getWebappUrl = ( identifierList ) => {
        if ( Array.isArray( identifierList ) ) {
            return identifierList.find( ( id ) =>
                ( id || '' ).toLowerCase().indexOf( 'myawardsite.com' ) >= 0 );
        } else {
            return '';
        }
    };

    getCelebrationUrl = ( identifierList, celebrationId ) => {
        if ( celebrationId ) {
            return `${ this.getWebappUrl( identifierList ) }/celebration/${ celebrationId }`;
        } else {
            return '';
        }
    };
    getContributors = async ( recipientId ) => {
        const firstFetch = await fetch( `${ saURL }/recipients/${ recipientId }/contributors?type=managers`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        } );

        const firstResponse = await firstFetch.json();
        if ( !firstResponse.success ) {
            throw firstResponse;
        }
        const { managers } =  firstResponse;

        // this may error if there are too many contributors
        let internal = [];
        let external = [];
        let excessiveContributors = false;

        const secondFetch = await fetch( `${ saURL }/recipients/${ recipientId }/contributors?type=internal,external`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        } );

        const secondResponse = await secondFetch.json();
        if ( secondResponse.success ) {
            internal = secondResponse.internal;
            external = secondResponse.external;
        } else {
            if ( secondResponse.errors && secondResponse.errors[ 0 ].code === 'serviceAwards.error.excessiveContributors' ) {
                excessiveContributors = true;
            } else {
                throw secondResponse;
            }
        }

        return  {
            managers,
            external,
            internal,
            excessiveContributors
        };
    };
    resendEmail = ( recipientId, contributionId, type ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/recipients/${ recipientId }/contributors/${ contributionId }/emails/${ type }`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' }
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                }
            } )
            .catch( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };
    searchContributors = ( searchString, recipientId ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ saURL }/recipients/${ recipientId }/team-members/search`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( {
                    searchInput: searchString
                } )

            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( new Error( data ) );
                    } );
                }
            } )
            .catch( ( err ) => {
                console.error( err );
                reject( new Error( err.message ) );
            } );
        } );
    };
    searchRecipients = async ( filters = {}, properties ) => {
        const res = await fetch( `${ saURL }/celebrations/search`, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify( {
                ...filters,
                properties: [ ...properties, 'fullRecipient', 'count' ]
            } )
        } );

        const response = await res.json();
        if ( res.ok ) {
            return response;
        }
        throw response;
    };
    loadAllProcedures = async () => {
        const res = await fetch( `${ saURL }/procedures` );
        if ( res.ok ) {
            return await res.json();
        } else {
            return [];
        }
    };
    getProcedureRetry = async () => {
        const res = await fetch( `${ saURL }/procedure-attempts/retry` );
        if ( res.ok ) {
            return await res.json();
        } else {
            return [];
        }
    };
    clearProcedureAttemptsForProgram = async ( procedureKey, programId ) => {
        const res = await fetch( `${ saURL }/procedure-attempts/${ encodeURIComponent( procedureKey ) }/programs/${ encodeURIComponent( programId ) }`, {
            method: 'PUT'
        } );
        if ( res.ok ) {
            return await res.json();
        } else {
            return [];
        }
    };

    getMostRecentProcedure = async () => {
        const res = await fetch( `${ saURL }/procedures/most-recent` );
        if ( res.ok ) {
            return await res.json();
        } else {
            return [];
        }
    };
    getLastFewProcedures = async ( all = false ) => {
        const res = await fetch( `${ saURL }/procedures/${ all ? 'all' : 'companies' }` );
        if ( res.ok ) {
            return await res.json();
        } else {
            return [];
        }
    };
    getMostRecentEvent = async () => {
        //const res = await fetch( `${ saURL }/events/companies` );
        const res = await fetch( `${ saURL }/events/most-recent` );
        if ( res.ok ) {
            return await res.json();
        } else {
            return [];
        }
    };
    getLastFewEvents = async( all = false ) => {
        const res = await fetch( `${ saURL }/events/${ all ? 'all' : 'companies' }` );
        if ( res.ok ) {
            return await res.json();
        } else {
            return [];
        }
    };


    getProgramIssues = async ( programId ) => {
        const res = await fetch( `${ saURL }/programs/${ programId }/issues` );
        if ( res.ok ) {
            return await res.json();
        } else {
            return null;
        }
    };
    findProgramIssues = async( programId ) => {
        const res = await fetch( `${ saURL }/programs/${ programId }/issues`, {
            method: 'POST'
        } );
        if ( res.ok ) {
            return await res.json();
        } else {
            return null;
        }
    };

    cancelAndReissue = async( programId, giftCode, milestoneCode ) => {
        const res = await fetch( `${ saURL }/recipients/gift-codes/status`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify( {
                action: 'CANCELLED_REISSUED',
                giftCodeId: giftCode.giftCodeId,
                programNumber: giftCode.programNumber,
                giftCode: giftCode.giftCode,
                referenceNumber: giftCode.referenceNumber,
                issuedAt: giftCode.issuedAt,
                countryCode: giftCode.countryCode,
                newGiftCode: {
                    levelName: milestoneCode
                },
                source: 'STUDIO'
            } )
        } );
        if ( res.ok ) {
            return await res.json();
        } else {
            return null;
        }
    };

    revertPoints = async( recipientId ) => {
        const res = await fetch( `${ saURL }/recipients/${ encodeURIComponent( recipientId ) }/points/revert`, {
            method: 'POST'
        } );
        if ( res.ok ) {
            return await res.json();
        } else {
            return null;
        }
    };

    getCriteriaMessages = async ( programId ) => {
        const res = await fetch( `${ saURL }/programs/${ encodeURIComponent( programId ) }/criteria-messages`, {
            method: 'GET'
        } );
        const response = await res.json();
        if ( res.ok ) {
            return response;
        }
        throw response;
    };

    createCriteriaMessage = async ( programId, message ) => {
        const res = await fetch( `${ saURL }/programs/${ encodeURIComponent( programId ) }/criteria-messages`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify( message )
        } );
        const response = await res.json();
        if ( res.ok ) {
            return response;
        }
        throw response;
    };

    updateCriteriaMessage = async ( programId, message ) => {
        const res = await fetch( `${ saURL }/programs/${ encodeURIComponent( programId ) }/criteria-messages/${ encodeURIComponent( message.id ) }`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify( message )
        } );
        const response = await res.json();
        if ( res.ok ) {
            return response;
        }
        throw response;
    };

    deleteCriteriaMessage = async ( programId, messageId ) => {
        const res = await fetch( `${ saURL }/programs/${ encodeURIComponent( programId ) }/criteria-messages/${ encodeURIComponent( messageId ) }`, {
            method: 'DELETE'
        } );
        const response = await res.json();
        if ( res.ok ) {
            return response;
        }
        throw response;
    };

    refreshCriteriaMessage = async ( recipientId ) => {
        const res = await fetch( `${ saURL }/recipients/${ encodeURIComponent( recipientId ) }/criteria-message`, {
            method: 'POST'
        } );
        const response = await res.json();
        if ( res.ok ) {
            return response;
        }
        throw response;
    };


    getBulkContributionGroups = async ( programId ) => {
        const res = await fetch( `${ saURL }/bulk-contribution-groups?programId=${ encodeURIComponent( programId ) }` );

        const response = await res.json();
        if ( res.ok ) {
            return response;
        }
        throw response;
    };
    createBulkContributionGroup = async ( group ) => {
        const res = await fetch( `${ saURL }/bulk-contribution-groups`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify( group )
        } );
        const response = await res.json();
        if ( res.ok ) {
            return response;
        }
        throw response;
    };
    updateBulkContributionGroup = async ( groupId, group ) => {
        const res = await fetch( `${ saURL }/bulk-contribution-groups/${ encodeURIComponent( groupId )  }`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify( group )
        } );
        const response = await res.json();
        if ( res.ok ) {
            return response;
        }
        throw response;
    };
    deleteBulkContributionGroup = async ( groupId ) => {
        const res = await fetch( `${ saURL }/bulk-contribution-groups/${ encodeURIComponent( groupId )  }`, {
            method: 'DELETE'
        } );
        const response = await res.json();
        if ( res.ok ) {
            return response;
        }
        throw response;
    };
    deleteRecipient = async ( recipientId ) => {
        const res = await fetch( `${ saURL }/recipients/${ encodeURIComponent( recipientId ) }`, {
            method: 'DELETE'
        } );
        const response = await res.json();
        if ( res.ok ) {
            return response;
        }
        throw response;
    };
    reEmitEvent = async ( { recipientId, awardFileId } ) => {
        const res = await fetch( `${ saURL }/events/award`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify( { recipientId, awardFileId } )
        } );
        const response = await res.json();
        if ( res.ok ) {
            return response;
        }
        throw response;
    };
    inviteContributors = async ( contributors ) => {
        const res = await fetch( `${ saURL }/contributors`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify( { contributors, shouldRetry: true, validateRole: true } )
        } );
        const response = await res.json();
        if ( res.ok ) {
            return response;
        }
        throw response;
    };
    updateProgramName = async ( programId, name ) => {
        const res = await fetch( `${ saURL }/programs/${ encodeURIComponent( programId ) }/updateName`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify( { programName: name } )
        } );
        const response = await res.json();
        if ( res.ok ) {
            return response;
        }   
        throw response;
    };
}

export default new ServiceAwardsSDK();

export const AwardTypes = {
    none: 'None',
    giftCode: 'Gift Code',
    points: 'Points'
};

export const AwardFileTypes = {
    award: 'AWARD',
    awardPerson: 'AWARD_PERSON',
    awardPersonManager: 'AWARD_PERSON_MANAGER'
};
